<script>
const CountryListAPI = "https://ams4you.net/amsapi/public/websearch/GetAcaCountryList";
const CountryChangeAPI = "https://ams4you.net/amsapi/public/websearch/GetAcaCountryChange";
import axios from "axios";
export default {
    data() {
        return {
            query: "",
            SelCountry: {},
            SelLevel: [],
            Keyword: "",
            LevelLabel: "",
            CountryList: [],
            LevelList: [],
            LevelMenu: false,
        };
    },
    computed: {
        Setting() {
            return this.$parent.Setting;
        },
        Translation() {
            return this.$parent.Translation;
        },
    },
    watch: {
        SelCountry(val) {
            this.SelLevel = [];
            this.LevelList = [];
            if (val?.Id) {
                let LatestQuery = this.query + "&CountryId=" + val.Id;
                this.GetLevels(LatestQuery);
            }
        },
        SelLevel: {
            handler(val) {
                if (val.length) {
                    if (val?.length == 1) {
                        let first = val[0].Name;
                        first = val[0].Name?.length > 14 ? val[0].Name.slice(0, 14) + "..." : val[0].Name;
                        this.LevelLabel = first;
                    } else if (val?.length > 1 && val?.length < this.LevelList?.length) {
                        let first = val[0].Name;
                        first = val[0].Name?.length > 14 ? val[0].Name.slice(0, 14) + "..." : val[0].Name;
                        this.LevelLabel = first + `(+${val.length - 1} More)`;
                    } else if (val?.length == this.LevelList?.length) {
                        this.LevelLabel = "All Levels";
                    } else {
                        this.LevelLabel = this.Translation.SelectLevel;
                    }
                } else {
                    this.LevelLabel = this.Translation.SelectLevel;
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        MakeSearch() {
            let Path = this.Setting.Url + "/search/academic";
            let SelLevelIds = this.SelLevel.map((el) => el.Id).join("-");
            let query = "?CountryId=" + this.SelCountry.Id + "&LevelId=" + SelLevelIds + "&Keyword=" + this.Keyword;
            window.open(Path + query, this.Setting.OpenInNewWindow ? "_blank" : "_self");
        },
        async GetCountries() {
            let ag = this.$parent.ag;
            let wid = this.$parent.wid;
            this.query = "?ag=" + ag + "&wfid=" + wid;
            const request = await axios.get(CountryListAPI + this.query);
            const response = request.data;
            this.CountryList = response.detail;
        },
        async GetLevels(query) {
            const request = await axios.get(CountryChangeAPI + query);
            const response = request.data;
            this.LevelList = response.detail;
        },
    },
    mounted() {
        this.GetCountries();
    },
};
</script>
<template>
    <div class="widget">
        <div class="widget-content">
            <div class="form-row">
                <div class="form-row-icon" v-if="this.Setting.ShowIcons">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-globe2" viewBox="0 0 16 16">
                        <path
                            d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855-.143.268-.276.56-.395.872.705.157 1.472.257 2.282.287V1.077zM4.249 3.539c.142-.384.304-.744.481-1.078a6.7 6.7 0 0 1 .597-.933A7.01 7.01 0 0 0 3.051 3.05c.362.184.763.349 1.198.49zM3.509 7.5c.036-1.07.188-2.087.436-3.008a9.124 9.124 0 0 1-1.565-.667A6.964 6.964 0 0 0 1.018 7.5h2.49zm1.4-2.741a12.344 12.344 0 0 0-.4 2.741H7.5V5.091c-.91-.03-1.783-.145-2.591-.332zM8.5 5.09V7.5h2.99a12.342 12.342 0 0 0-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5c.035.987.176 1.914.399 2.741A13.612 13.612 0 0 1 7.5 10.91V8.5H4.51zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741H8.5zm-3.282 3.696c.12.312.252.604.395.872.552 1.035 1.218 1.65 1.887 1.855V11.91c-.81.03-1.577.13-2.282.287zm.11 2.276a6.696 6.696 0 0 1-.598-.933 8.853 8.853 0 0 1-.481-1.079 8.38 8.38 0 0 0-1.198.49 7.01 7.01 0 0 0 2.276 1.522zm-1.383-2.964A13.36 13.36 0 0 1 3.508 8.5h-2.49a6.963 6.963 0 0 0 1.362 3.675c.47-.258.995-.482 1.565-.667zm6.728 2.964a7.009 7.009 0 0 0 2.275-1.521 8.376 8.376 0 0 0-1.197-.49 8.853 8.853 0 0 1-.481 1.078 6.688 6.688 0 0 1-.597.933zM8.5 11.909v3.014c.67-.204 1.335-.82 1.887-1.855.143-.268.276-.56.395-.872A12.63 12.63 0 0 0 8.5 11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.963 6.963 0 0 0 14.982 8.5h-2.49a13.36 13.36 0 0 1-.437 3.008zM14.982 7.5a6.963 6.963 0 0 0-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008h2.49zM11.27 2.461c.177.334.339.694.482 1.078a8.368 8.368 0 0 0 1.196-.49 7.01 7.01 0 0 0-2.275-1.52c.218.283.418.597.597.932zm-.488 1.343a7.765 7.765 0 0 0-.395-.872C9.835 1.897 9.17 1.282 8.5 1.077V4.09c.81-.03 1.577-.13 2.282-.287z"
                        />
                    </svg>
                </div>
                <v-select
                    class="form-control"
                    :options="CountryList"
                    label="Name"
                    :getOptionLabel="(option) => option.Name || Translation.SelectCountry"
                    :clearable="false"
                    v-model="SelCountry"
                    :placeholder="Translation.SelectCountry"
                />
            </div>
            <div class="form-row">
                <div class="form-row-icon" v-if="this.Setting.ShowIcons">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-book" viewBox="0 0 16 16">
                        <path
                            d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z"
                        />
                    </svg>
                </div>
                <div class="dropdown w-100 pe-4" id="VDropCnt" :class="{'pe-none': !SelCountry?.Id}">
                    <button
                        type="button"
                        :class="{show: LevelMenu, 'pe-none': !SelCountry?.Id}"
                        @click="LevelMenu = !LevelMenu"
                        class="btn btn-input btn-dropdown dropdown-dark text-start"
                        :disabled="!SelCountry?.Id"
                        id="VDropBtn"
                    >
                        <span class="btn-input-selected text-dark" id="VDropLbl" :class="{'pe-none': !SelCountry?.Id}">{{ LevelLabel }}</span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-animate dropdown-menu-list w-100" :class="{show: LevelMenu}" id="VDrop">
                        <button type="button" class="btn btn-dropdown-close" data-bs-toggle="dropdown" aria-expanded="false" @click="LevelMenu = !LevelMenu">
                            <svg width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="m4.21 4.387.083-.094a1 1 0 0 1 1.32-.083l.094.083L12 10.585l6.293-6.292a1 1 0 1 1 1.414 1.414L13.415 12l6.292 6.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.32.083l-.094-.083L12 13.415l-6.293 6.292a1 1 0 0 1-1.414-1.414L10.585 12 4.293 5.707a1 1 0 0 1-.083-1.32l.083-.094-.083.094Z"
                                    fill="#333"
                                />
                            </svg>
                        </button>
                        <div class="dropdown-close-list">
                            <li v-for="(item, index) in LevelList" :key="item.Id" class="filter-checkbox-list-item form-check">
                                <input class="form-check-input" type="checkbox" :id="'lvl_' + item.Id" :value="{Name: item.Name, Id: item.Id}" v-model="SelLevel" />
                                <label class="form-check-label" :for="'lvl_' + item.Id">{{ item.Name }} ({{ item.progCount }})</label>
                            </li>
                        </div>
                    </ul>
                </div>
            </div>
            <div class="form-row">
                <div class="form-row-icon" v-if="this.Setting.ShowIcons">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-binoculars" viewBox="0 0 16 16">
                        <path
                            d="M3 2.5A1.5 1.5 0 0 1 4.5 1h1A1.5 1.5 0 0 1 7 2.5V5h2V2.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5v2.382a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V14.5a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 14.5v-3a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5v3A1.5 1.5 0 0 1 5.5 16h-3A1.5 1.5 0 0 1 1 14.5V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V2.5zM4.5 2a.5.5 0 0 0-.5.5V3h2v-.5a.5.5 0 0 0-.5-.5h-1zM6 4H4v.882a1.5 1.5 0 0 1-.83 1.342l-.894.447A.5.5 0 0 0 2 7.118V13h4v-1.293l-.854-.853A.5.5 0 0 1 5 10.5v-1A1.5 1.5 0 0 1 6.5 8h3A1.5 1.5 0 0 1 11 9.5v1a.5.5 0 0 1-.146.354l-.854.853V13h4V7.118a.5.5 0 0 0-.276-.447l-.895-.447A1.5 1.5 0 0 1 12 4.882V4h-2v1.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V4zm4-1h2v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V3zm4 11h-4v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14zm-8 0H2v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14z"
                        />
                    </svg>
                </div>
                <input id="searchboxText" type="text" class="form-control" :placeholder="Translation.ProgramName" v-model="Keyword" />
            </div>
        </div>
        <div class="widget-footer">
            <button type="submit" class="btn fw-500 px-4 text-center flex-grow-1" :disabled="!SelCountry?.Id || !SelLevel?.length" @click="MakeSearch()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search me-1 fs-9" viewBox="0 0 16 16" v-if="this.Setting.ShowIcons">
                    <path
                        d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
                    />
                </svg>
                {{ Translation.Search }}
            </button>
        </div>
    </div>
</template>
